<template>
    <div class="form_item form_item-w">
        <p class="form_item_title">Страховий період на фазу цвітіння </p>
        <div class="form-group col-md-6">
            <div>
                <button class=" dropdown-toggle dropDownStyle  w-100 styledBtn" data-toggle="dropdown" aria-expanded="true">
                    <span v-if="selectedRiskPeriod !== null" class="">{{ selectedRiskPeriod.date_from_text }} - {{ selectedRiskPeriod.date_to_text }}</span>
                </button>
                <div class="dropdown-menu dropdown-menu-scale dDMStyle styledDW">
                    <span v-for="riskPeriod in riskPeriods" class="dropdown-item" @click="selectRiskPeriod(riskPeriod)">{{ riskPeriod.date_from_text }} - {{ riskPeriod.date_to_text }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RiskPeriodSelectComponent",
    props: {
        riskPeriodsLoadUrl: String,

        regionId: null,
        cropId: null,
        meteoPointId: null,
    },

    data: function () {
        return {
            riskPeriods: Array,
            selectedRiskPeriod: null,
        };
    },

    mounted() {
        this.updateRiskPeriods();
    },

    watch: {
        regionId(val) {
            this.updateRiskPeriods();
        },

        cropId(val) {
            this.updateRiskPeriods();
        },

        meteoPointId(val) {
            this.updateRiskPeriods();
        }
    },

    methods: {
        selectRiskPeriod(riskPeriod) {
            this.selectedRiskPeriod = riskPeriod;
            this.$emit('risk-period-selected', riskPeriod.id);
        },

        updateRiskPeriods() {
            if(this.regionId !== null && this.cropId !== null && this.meteoPointId !== null) {
                axios.get(this.riskPeriodsLoadUrl, {
                    params: {
                        region_id: this.regionId,
                        crop_id: this.cropId,
                        meteo_point_id: this.meteoPointId
                    }
                }).then((response) => {
                    this.riskPeriods = response['data']['data'];
                    if(this.riskPeriods.length > 0) {
                        this.selectRiskPeriod(this.riskPeriods[0]);
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$eventBus.$emit('alert', 'error', 'Під час завантаження дани виникла помилка!');
                });
            }
        }
    }
}
</script>

<style scoped>

</style>
